import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/error-icon.png'
import _imports_1 from '@assets/images/star.png'
import _imports_2 from '@assets/images/standard.png'


const _hoisted_1 = { class: "score" }
const _hoisted_2 = { class: "score-top" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = {
  key: 0,
  class: "warn-box"
}
const _hoisted_6 = { class: "box" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "item-right" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = {
  key: 0,
  class: "item-right",
  style: {"color":"#46B65B"}
}
const _hoisted_12 = {
  key: 1,
  class: "item-right",
  style: {"color":"#E70102"}
}
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "trainsmit" }
const _hoisted_15 = { class: "typeList" }
const _hoisted_16 = { class: "trainsmit-fliying-info" }
const _hoisted_17 = { class: "flying-info-item" }
const _hoisted_18 = { class: "info-box" }
const _hoisted_19 = { class: "progress-box" }
const _hoisted_20 = { class: "flying-info-item" }
const _hoisted_21 = { class: "info-box" }
const _hoisted_22 = { class: "progress-box" }
const _hoisted_23 = { class: "footer-container-btn" }
const _hoisted_24 = {
  key: 0,
  class: "audio-detail-container"
}

import { ref, reactive,onBeforeMount, getCurrentInstance } from 'vue';
import { exportAirLinePointActions } from '@/service'
import AudioDetail from '@/views/audio/index.vue'
import {downloadFile} from '@/utils/index'
import { getSimulatorTrainingDetail } from '@/service'
import { $enum,$config } from '@/global'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  id: {
    required: true,
    default: '',
  },
  mistakeName:{
    default: '',
  },
  sceneTypeId:{
    typeof:[String,Number],
    default: '',
  },
  crash:{
    typeof:Boolean,
    default: false,
  },
},
  emits: ['onClose'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { proxy } = getCurrentInstance()!
const props = __props;
const emit = __emit
const showModel = ref(false);
const state = reactive({
  data: {
    overallTime: '',
    "overallScore": '',
    "isPass": true,
    "pictureUrl": "",
  },
  showAudioView:false,
  loading:false
} as any)

async function onGetSimulatorTrainingDetail() {
  const { code, data } = await getSimulatorTrainingDetail({ id: props.id }) as any;
  if (code === $enum.EnumResult.SUCCESS) {
    state.data = data
  }
}

function handleClose() {
  window?.playClick();
  showModel.value = false;
  emit('onClose')
}
function formatFlexibleTime(timeStr:string) {
  const totalSeconds = Number(timeStr);
  if (isNaN(totalSeconds)) return "00:00";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (hours === 0 && minutes === 0 && seconds === 0) {
    return "00:00";
  } else if (hours === 0 && minutes === 0) {
    return `00:${String(seconds).padStart(2, '0')}`;
  } else if (hours === 0) {
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  } else {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
}

async function handleDownload(){
  window?.playClick();
  state.loading = true
  const response = await exportAirLinePointActions({id: props.id})
  state.loading = false
  if(response.status !== 200){
    proxy?.vknMessage.error('下载报告失败，请稍后再试')
    return
  }
  downloadFile(response, 'docx')
}

function handleToAudio(){
  state.showAudioView = true
}
__expose({ showModel })
onBeforeMount(()=>{
  onGetSimulatorTrainingDetail()
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_vkm_modal, {
      class: _normalizeClass(['grade-modal-container','trainsmait-container']),
      title: "成绩",
      onOnClose: handleClose,
      isFooter: true
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_vkm_svg, {
                "icon-name": "clock",
                class: "icon"
              }),
              _createElementVNode("span", _hoisted_4, _toDisplayString(formatFlexibleTime(state.data?.overallTime)), 1)
            ]),
            (props.crash)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1),
                  _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "item-left" }, [
                  _createElementVNode("img", { src: _imports_1 }),
                  _createElementVNode("span", null, "得分")
                ], -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(state.data?.overallScore), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "item-left" }, [
                  _createElementVNode("img", { src: _imports_2 }),
                  _createElementVNode("span", null, "评价")
                ], -1)),
                (state.data?.isPass)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 合格 "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, " 不合格 "))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "inner",
                  onClick: handleToAudio
                }, [
                  _createVNode(_component_vkm_svg, {
                    "icon-name": "showFiles",
                    class: "icon"
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "查看结果", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "完成总数", -1)),
                  _createElementVNode("span", null, _toDisplayString(state.data?.actionNum) + " / " + _toDisplayString(state.data?.pointNum), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "progress-inner",
                    style: _normalizeStyle({width:(state.data?.actionNum/state.data?.pointNum)*100+'%',backgroundColor:state.data?.actionNum < state.data?.pointNum? '#C60B12':'#2174FF'})
                  }, null, 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "合格照片数", -1)),
                  _createElementVNode("span", null, _toDisplayString(state.data?.passNum) + " / " + _toDisplayString(state.data?.pointNum), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: "progress-inner",
                    style: _normalizeStyle({width:(state.data?.passNum/state.data?.pointNum)*100+'%',backgroundColor:state.data?.passNum < state.data?.pointNum? '#C60B12':'#2174FF'})
                  }, null, 4)
                ])
              ])
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_vkn_button, {
            label: "下载报告",
            type: "info",
            size: "medium",
            onClick: handleDownload,
            loading: state.loading
          }, {
            icon: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "iconfont-line vk_xz_line" }, null, -1)
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }),
    (state.showAudioView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(AudioDetail, {
            trainId: props.id,
            onOnBack: _cache[0] || (_cache[0] = ()=>{state.showAudioView = false})
          }, null, 8, ["trainId"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})